import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

import { makeStyles } from '@material-ui/core/styles';
import { orange, red } from '@material-ui/core/colors';

import Categoria from '../../components/Categoria/Categoria';
import Divisor from "../../components/Divisor/Divisor";

const useStyles = makeStyles((theme) => (
    {    
        warning: {
            backgroundColor: orange[400],
            color: "#fff",
        },
        error: {
            backgroundColor: red[400],
            color: "#fff",
        },
    }
));

const InformacoesTratamentoPlanilha = ({ totalLinhas, totalErros, totalProcessamento, erros }) => {
    const classes = useStyles();

    return (
        <>
            <Grid container item spacing={2} style={{ paddingBottom: 6 }} >
                <Grid item sm={6} lg={12}>
                    <Typography variant="body2"><b>Relatório de Tratamento de Dados da Última Planilha Importada</b>:</Typography>
                </Grid>
            </Grid>

            <Grid container item spacing={2} style={{ paddingTop: 2, paddingBottom: 6 }}>
                <Grid item sm={12} lg={3}>
                    <Typography variant="body2"><b>Total de Linhas Lidas</b>: {totalLinhas}</Typography>
                </Grid>

                <Grid item sm={6} lg={3}>
                    <Typography variant="body2"><b>Total de Linhas para Processamento</b>: {totalProcessamento}</Typography>
                </Grid>

                <Grid item sm={6} lg={3}>
                    <Typography variant="body2" style={{ display: "inline" }} ><b>Total de Linhas com Problemas</b>: </Typography> 
                    {totalErros > 0 ? <Chip size="small" label={<b>{totalErros}</b>} className={classes.error} /> : totalErros}
                </Grid>
            </Grid>

            { (totalErros > 0 && erros.length > 0) &&
                <Categoria 
                    style={{ paddingBottom: 6 }}
                    defaultExpanded={totalErros <= 12} 
                    nome={<><b>Descrição das Linhas com Problemas</b> <Chip size="small" label={<b>{totalErros}</b>} className={classes.error} /></>}
                >
                    <Grid container spacing={2} >
                        {erros.map((err, index) => (
                            <Grid item xs={12} lg={12 / Math.min(totalErros, 3)} key={index} >
                                <Typography variant="body2"><Chip size="small" label={<b>Linha {err.linha}</b>} className={classes.warning} /> {err.erro}</Typography>
                            </Grid>
                        ))}
                    </Grid>
                </Categoria>
            }

            <Divisor />
        </>
    )
}

export default InformacoesTratamentoPlanilha;